import { DateFields, Services } from '@sigma-frontend-libs/commons'
import { OrderDirections } from '@sigmasms/shared-types'

import { serviceTemplate } from '@/utils'

export default {
  mixins: [
    serviceTemplate({
      serviceName: `${Services['report-manager/recurrent']}`,

      backendGeneration: 'nest',

      find: {
        defaultFilter: {
          name: undefined,
          type: undefined,
          status: undefined,
          ownerId: undefined,
          createdAtPreset: undefined,
          createdAt: {
            gte: undefined,
            lt: undefined
          }
        },
        defaultOrder: {
          orderField: DateFields.createdAt,
          orderDirection: OrderDirections.DESC
        }
      },

      update: false,

      has: {
        tabs: false,
        clone: false,
        support: false
      },

      formClass: '',
      titlePath: 'name'
    })
  ]
}
